/* LANTURN kabelkiezer: kies vermogen en lengte, zie direct prijs en voorraad, voeg toe aan winkelwagen. */
(function () {
  var root0 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function track(e, d) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: e }, d)); } catch (x) {} }
  function fmt(kw) { return String(kw).replace('.', ','); }
  document.querySelectorAll('[data-lt-cs]').forEach(function (root) {
    var items = JSON.parse(root.querySelector('[data-cs-data]').textContent).filter(Boolean);
    var low = parseInt(root.dataset.low, 10) || 5;
    var $ = function (s) { return root.querySelector(s); };
    var powerBtns = [].slice.call(root.querySelectorAll('[data-cs-kw]'));
    var lenBtns = [].slice.call(root.querySelectorAll('[data-cs-m]'));
    var out = $('[data-cs-out]'), prompt = $('[data-cs-prompt]'), add = $('[data-cs-add]'), more = $('[data-cs-more]');
    var chipKw = $('[data-cs-chip-kw]'), chipM = $('[data-cs-chip-m]');
    var state = { kw: null, m: null };
    var list = $('[data-cs-list]');
    if (list) [].slice.call(list.children).sort(function (a, b) { return (a.dataset.sortKw - b.dataset.sortKw) || (a.dataset.sortM - b.dataset.sortM); }).forEach(function (li) { list.appendChild(li); });
    function find(kw, m) { return items.filter(function (i) { return i.kw === kw && i.m === m; })[0]; }
    function cheapest(kw) { return items.filter(function (i) { return i.kw === kw; }).sort(function (a, b) { return a.cents - b.cents; })[0]; }
    function paint() {
      powerBtns.forEach(function (b) {
        var min = cheapest(b.dataset.csKw);
        b.disabled = !min;
        b.setAttribute('aria-pressed', String(b.dataset.csKw === state.kw));
        b.querySelector('[data-cs-from]').textContent = min ? 'vanaf ' + min.price : 'niet beschikbaar';
      });
      lenBtns.forEach(function (b) {
        var hit = state.kw ? find(state.kw, b.dataset.csM) : null;
        b.disabled = !hit;
        b.setAttribute('aria-pressed', String(b.dataset.csM === state.m));
        b.querySelector('[data-cs-price]').textContent = hit ? hit.price : '';
      });
      var sel = state.kw && state.m ? find(state.kw, state.m) : null;
      chipKw.hidden = !state.kw; chipKw.textContent = state.kw ? fmt(state.kw) + ' kW' : '';
      chipM.hidden = !state.m; chipM.textContent = state.m ? state.m + ' m' : '';
      if (!sel) {
        out.hidden = true; more.hidden = true; prompt.hidden = false;
        prompt.textContent = state.kw ? 'Kies nu de lengte om je prijs te zien.' : 'Kies eerst het vermogen.';
        add.disabled = true; add.textContent = 'In winkelwagen'; add._item = null;
        return;
      }
      prompt.hidden = true; out.hidden = false;
      $('[data-cs-title]').textContent = 'Type 2 · ' + fmt(sel.kw) + ' kW · ' + sel.m + ' m';
      $('[data-cs-sub]').textContent = sel.ph + '-fase · ' + sel.a + ' A';
      $('[data-cs-total]').textContent = sel.price;
      var lowStock = sel.ok && sel.mg && sel.q > 0 && sel.q <= low;
      var st = $('[data-cs-stock]');
      st.textContent = !sel.ok ? 'Tijdelijk uitverkocht' : (lowStock ? 'Bijna op: nog ' + sel.q + ' op voorraad' : 'Op voorraad');
      st.className = 'lt-cs-stock' + (!sel.ok ? ' is-out' : (lowStock ? ' is-low' : ''));
      add.disabled = !sel.ok; add.textContent = sel.ok ? 'In winkelwagen' : 'Tijdelijk uitverkocht'; add._item = sel;
      more.href = sel.url; more.hidden = false;
    }
    function sync() {
      try {
        var u = new URL(location.href);
        if (state.kw) u.searchParams.set('kw', state.kw); else u.searchParams.delete('kw');
        if (state.m) u.searchParams.set('m', state.m); else u.searchParams.delete('m');
        history.replaceState(null, '', u);
      } catch (x) {}
    }
    powerBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.kw = b.dataset.csKw;
        if (state.m && !find(state.kw, state.m)) state.m = null;
        track('cable_power_select', { kw: state.kw }); sync(); paint();
      });
    });
    lenBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.m = b.dataset.csM;
        track('cable_length_select', { m: state.m }); sync(); paint();
        if (window.matchMedia('(max-width: 989px)').matches) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
    add.addEventListener('click', function () {
      var it = add._item; if (!it) return;
      add.disabled = true; add.textContent = 'Toevoegen...';
      fetch(root0 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: it.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); track('cable_add_to_cart', { kw: it.kw, m: it.m }); location.href = root0 + 'cart'; })
        .catch(function () { add.disabled = false; add.textContent = 'Opnieuw proberen'; });
    });
    try {
      var p = new URLSearchParams(location.search), kw = (p.get('kw') || '').replace(',', '.'), m = p.get('m') || '';
      if (kw && cheapest(kw)) { state.kw = kw; if (m && find(kw, m)) state.m = m; }
    } catch (x) {}
    paint();
  });
})();